import { SHARED_INPUT_CLASS } from './pageMeta';

/** Prompt + points inputs shared by every question editor. */
export function QuestionCommonFields({
  prompt,
  points,
  optional,
  onPrompt,
  onPoints,
  onOptional,
  promptLabel = 'Question',
  graded = true,
}: {
  prompt: string;
  points: number;
  /** False hides the points box: an unmarked assessment has no score to weight. */
  graded?: boolean;
  /** When set, the learner can finish without answering this one. */
  optional?: boolean;
  onPrompt: (next: string) => void;
  onPoints: (next: number) => void;
  /** Omit to hide the optional toggle for question types it makes no sense on. */
  onOptional?: (next: boolean) => void;
  /** Label over the prompt input (e.g. "Statement" for true/false). */
  promptLabel?: string;
}) {
  return (
    <div className="flex flex-wrap items-end gap-3">
      <label className="min-w-64 flex-1 text-sm">
        <span className="font-medium text-fg-muted">{promptLabel}</span>
        <input
          value={prompt}
          onChange={(e) => onPrompt(e.target.value)}
          placeholder="e.g. Why should cables not be left in walk ways?"
          className={SHARED_INPUT_CLASS}
        />
      </label>
      {graded ? (
        <label className="w-24 text-sm">
          <span className="font-medium text-fg-muted">Points</span>
          <input
            type="number"
            min={1}
            max={100}
            value={points}
            onChange={(e) => onPoints(Math.max(1, Math.floor(Number(e.target.value) || 1)))}
            className={SHARED_INPUT_CLASS}
          />
        </label>
      ) : null}
      {onOptional ? (
        <label className="flex items-center gap-2 pb-2 text-sm text-fg">
          <input
            type="checkbox"
            checked={optional === true}
            onChange={(e) => onOptional(e.target.checked)}
          />
          <span title="The learner can finish without answering this one">Optional</span>
        </label>
      ) : null}
    </div>
  );
}
